// automatically generated by the FlatBuffers compiler, do not modify

import { ConnectionStatusMessage } from "../status/connection-status-message";
import { DoorStatusMessage } from "../status/door-status-message";
import { EarthquakeProtectionMessage } from "../status/earthquake-protection-message";
import { EarthquakeStatusMessage } from "../status/earthquake-status-message";
import { GeneralStatusMessage } from "../status/general-status-message";
import { LoadWeigherStatusMessage } from "../status/load-weigher-status-message";
import { ModeStatusMessage } from "../status/mode-status-message";
import { TrafficStatusMessage } from "../status/traffic-status-message";

export enum ElevatorStatusContent {
	NONE = 0,
	EarthquakeProtectionMessage = 1,
	EarthquakeStatusMessage = 2,
	GeneralStatusMessage = 3,
	ConnectionStatusMessage = 4,
	ModeStatusMessage = 5,
	DoorStatusMessage = 6,
	TrafficStatusMessage = 7,
	LoadWeigherStatusMessage = 8,
}

export function unionToElevatorStatusContent(
	type: ElevatorStatusContent,
	accessor: (
		obj:
			| ConnectionStatusMessage
			| DoorStatusMessage
			| EarthquakeProtectionMessage
			| EarthquakeStatusMessage
			| GeneralStatusMessage
			| LoadWeigherStatusMessage
			| ModeStatusMessage
			| TrafficStatusMessage
	) =>
		| ConnectionStatusMessage
		| DoorStatusMessage
		| EarthquakeProtectionMessage
		| EarthquakeStatusMessage
		| GeneralStatusMessage
		| LoadWeigherStatusMessage
		| ModeStatusMessage
		| TrafficStatusMessage
		| null
):
	| ConnectionStatusMessage
	| DoorStatusMessage
	| EarthquakeProtectionMessage
	| EarthquakeStatusMessage
	| GeneralStatusMessage
	| LoadWeigherStatusMessage
	| ModeStatusMessage
	| TrafficStatusMessage
	| null {
	switch (ElevatorStatusContent[type]) {
		case "NONE":
			return null;
		case "EarthquakeProtectionMessage":
			return accessor(new EarthquakeProtectionMessage())! as EarthquakeProtectionMessage;
		case "EarthquakeStatusMessage":
			return accessor(new EarthquakeStatusMessage())! as EarthquakeStatusMessage;
		case "GeneralStatusMessage":
			return accessor(new GeneralStatusMessage())! as GeneralStatusMessage;
		case "ConnectionStatusMessage":
			return accessor(new ConnectionStatusMessage())! as ConnectionStatusMessage;
		case "ModeStatusMessage":
			return accessor(new ModeStatusMessage())! as ModeStatusMessage;
		case "DoorStatusMessage":
			return accessor(new DoorStatusMessage())! as DoorStatusMessage;
		case "TrafficStatusMessage":
			return accessor(new TrafficStatusMessage())! as TrafficStatusMessage;
		case "LoadWeigherStatusMessage":
			return accessor(new LoadWeigherStatusMessage())! as LoadWeigherStatusMessage;
		default:
			return null;
	}
}

export function unionListToElevatorStatusContent(
	type: ElevatorStatusContent,
	accessor: (
		index: number,
		obj:
			| ConnectionStatusMessage
			| DoorStatusMessage
			| EarthquakeProtectionMessage
			| EarthquakeStatusMessage
			| GeneralStatusMessage
			| LoadWeigherStatusMessage
			| ModeStatusMessage
			| TrafficStatusMessage
	) =>
		| ConnectionStatusMessage
		| DoorStatusMessage
		| EarthquakeProtectionMessage
		| EarthquakeStatusMessage
		| GeneralStatusMessage
		| LoadWeigherStatusMessage
		| ModeStatusMessage
		| TrafficStatusMessage
		| null,
	index: number
):
	| ConnectionStatusMessage
	| DoorStatusMessage
	| EarthquakeProtectionMessage
	| EarthquakeStatusMessage
	| GeneralStatusMessage
	| LoadWeigherStatusMessage
	| ModeStatusMessage
	| TrafficStatusMessage
	| null {
	switch (ElevatorStatusContent[type]) {
		case "NONE":
			return null;
		case "EarthquakeProtectionMessage":
			return accessor(index, new EarthquakeProtectionMessage())! as EarthquakeProtectionMessage;
		case "EarthquakeStatusMessage":
			return accessor(index, new EarthquakeStatusMessage())! as EarthquakeStatusMessage;
		case "GeneralStatusMessage":
			return accessor(index, new GeneralStatusMessage())! as GeneralStatusMessage;
		case "ConnectionStatusMessage":
			return accessor(index, new ConnectionStatusMessage())! as ConnectionStatusMessage;
		case "ModeStatusMessage":
			return accessor(index, new ModeStatusMessage())! as ModeStatusMessage;
		case "DoorStatusMessage":
			return accessor(index, new DoorStatusMessage())! as DoorStatusMessage;
		case "TrafficStatusMessage":
			return accessor(index, new TrafficStatusMessage())! as TrafficStatusMessage;
		case "LoadWeigherStatusMessage":
			return accessor(index, new LoadWeigherStatusMessage())! as LoadWeigherStatusMessage;
		default:
			return null;
	}
}
